var _polygon, _path, _polygon2, _path2, _path3, _path4, _circle, _path5, _path6, _polygon3, _path7, _path8, _rect, _path9, _path10, _rect2, _rect3, _path11, _path12, _rect4, _rect5, _rect6, _path13, _path14, _path15, _polygon4, _path16, _polygon5, _path17, _polygon6, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUndrawTipImage2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eb138ea2-bd7e-4894-b46d-cd752eba296e",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 571.75671,
    height: 700.46347,
    viewBox: "0 0 571.75671 700.46347",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Giving feedback tip") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "237.145 687.3 249.405 687.3 255.239 640.012 237.145 640.012 237.145 687.3",
    fill: "#ffb8b8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M548.13974,783.06523h24.1438a15.40422,15.40422,0,0,1,15.387,15.38672v.5H548.13974Z",
    transform: "translate(-314.12165 -99.76826)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "79.05 664.069 89.559 670.383 118.914 632.854 103.404 623.535 79.05 664.069",
    fill: "#ffb8b8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M384.3707,772.41338l8.18188-13.61768,20.6958,12.43408a15.40476,15.40476,0,0,1,5.26465,21.11377l-.25757.42871Z",
    transform: "translate(-314.12165 -99.76826)",
    fill: "#2f2e41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M547.93124,777.15849c-2.47314-2.51806-8.6167-43.875-17.70678-106.68164-3.16114-21.84131-6.15284-42.51269-8.61768-58.34326-21.09351,46.37012-55.19556,96.53076-96.1748,141.43506l-.23609.25879-.32373-.1333c-13.10962-5.39844-15.54956-6.64942-21.44433-9.67188-1.7605-.90283-3.83106-1.96435-6.58887-3.34326l-.15259-.11816c-1.26611-1.44629,10.28491-20.61963,50.67212-85.813,17.59351-28.3999,35.78613-57.76611,47.8352-78.15332l.11231-.18994.21606-.04492c29.12769-6.07471,57.21314,1.05566,79.08277,20.07714l.17749.15479-.00586.23486c-.59009,23.90772-.09448,61.44824.343,94.57031.854,64.667.79809,83.55909-1.21631,84.15772l-.10132.019c-2.95239.24219-5.40283.48438-7.66187.70752a164.62926,164.62926,0,0,1-17.84936,1.02735l-.21143.001Z",
    transform: "translate(-314.12165 -99.76826)",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M484.43067,396.30226c-4.12706-17.0404-7.62358-36.26017.15974-51.95461,5.40044-10.88957,25.37863-14.5567,36.831-10.63361s19.73248,14.5667,23.37408,26.17159,3.21841,24.11,1.63126,36.17411C525.36428,395.65513,504.30181,395.25052,484.43067,396.30226Z",
    transform: "translate(-314.12165 -99.76826)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 205.85253,
    cy: 271.96835,
    r: 24.56103,
    fill: "#ffb8b8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M489.94857,366.67718a30.84951,30.84951,0,1,1,61.66193.81287C530.5881,367.53468,509.56571,367.57931,489.94857,366.67718Z",
    transform: "translate(-314.12165 -99.76826)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M586.45224,606.97734c-4.529-15.45117-6.78491-26.26514-9.39014-38.75391-3.57153-17.12011-7.61963-36.52441-18.77075-74.30322l-.02759-.09326.00928-.09619c3.15747-32.76465-10.6062-67.5332-35.91943-90.73828a8.7642,8.7642,0,0,0-11.96387.606c-14.241,15.99219-23.19092,30.97168-27.3606,45.79541l-.09008.32129c5.94531,19.13037,12.59887,38.356,19.03613,56.95606l.09228.26611-.18017.2168c-24.1001,29.01709-37.4292,67.80469-36.62622,106.52051a214.65391,214.65391,0,0,1,71.77685-12.01709A232.68628,232.68628,0,0,1,586.45224,606.97734Z",
    transform: "translate(-314.12165 -99.76826)",
    fill: "#3f3d56"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "186.941 382.463 223.217 461.44 243.941 440.463 186.941 382.463",
    opacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M698.7525,180.275c.345-44.18146-28.476-80.2248-64.37336-80.5051s-65.27769,35.30857-65.62268,79.49c-.31277,40.05573,23.34783,73.42112,54.52046,79.51237l-2.15206,12.89936,23.82252.186L642.997,258.92628C674.261,253.32257,698.43972,220.33073,698.7525,180.275Z",
    transform: "translate(-314.12165 -99.76826)",
    fill: "#4cbabb"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M590.59182,200.43107l-8.99973-.07027a146.49361,146.49361,0,0,1,.39823-50.99845l8.99972.07028Q584.94116,175.83637,590.59182,200.43107Z",
    transform: "translate(-314.12165 -99.76826)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 619.6142,
    y: 258.76497,
    width: 27,
    height: 6,
    transform: "translate(-312.05841 -104.70382) rotate(0.44739)",
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M823.82828,204.66981c3.498-44.04411-22.67651-82.05289-58.46226-84.895s-67.63166,30.55863-71.12967,74.60274C691.065,234.30874,712.28343,269.278,742.9417,277.579l-3.06739,12.71282,23.74847,1.88612-1.02227-13.03763C794.18471,275.78268,820.65691,244.601,823.82828,204.66981Z",
    transform: "translate(-314.12165 -99.76826)",
    fill: "#ff6584"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M714.50469,217.05338l-8.97175-.71254a146.4936,146.4936,0,0,1,4.03774-50.83991l8.97175.71254Q710.62414,192.11805,714.50469,217.05338Z",
    transform: "translate(-314.12165 -99.76826)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 739.04026,
    y: 278.26627,
    width: 27,
    height: 6,
    transform: "translate(-289.4912 -158.46502) rotate(4.54094)",
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 466.79411,
    y: 439.17102,
    width: 376.13849,
    height: 3.0002,
    transform: "translate(-377.12196 669.09304) rotate(-58.50618)",
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M874.62251,247.9391c20.78829-38.98675,11.96138-84.2842-19.71528-101.17464s-74.208,1.02208-94.99628,40.00883c-18.847,35.34612-13.351,75.87841,11.44542,95.72721l-7.887,10.4317,21.02155,11.209,4.26692-12.362C819.057,301.30811,855.77547,283.28522,874.62251,247.9391Z",
    transform: "translate(-314.12165 -99.76826)",
    fill: "#4cbabb"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M769.443,215.65476l-7.94157-4.23456A146.4937,146.4937,0,0,1,785.49729,166.418l7.94157,4.23456Q775.83846,191.24312,769.443,215.65476Z",
    transform: "translate(-314.12165 -99.76826)",
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 765.18522,
    y: 286.71272,
    width: 27,
    height: 6,
    transform: "translate(-86.23403 -432.07333) rotate(28.06716)",
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 479.38779,
    y: 441.3691,
    width: 376.13796,
    height: 3.0001,
    transform: "translate(-397.45648 622.28469) rotate(-53.96275)",
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 415.30797,
    y: 445.48174,
    width: 376.13841,
    height: 2.9998,
    transform: "matrix(0.17486, -0.98459, 0.98459, 0.17486, -256.3467, 863.1347)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M581.93882,566.17943a10.05577,10.05577,0,0,1-9.055-12.48052L542.9932,534.11506l17.04692-7.36451,25.77121,19.72622a10.11027,10.11027,0,0,1-3.87251,19.70266Z",
    transform: "translate(-314.12165 -99.76826)",
    fill: "#ffb8b8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M552.87485,551.72343c-17.875-20.564-36.35865-41.82812-53.18579-63.206l-.10791-.14355.00073-.17432c.0769-17.457.156-35.5044,2.22387-55.69531a15.98269,15.98269,0,0,1-4.23657-13.08741,17.72123,17.72123,0,0,1,7.78174-13.23388c8.42236-5.32032,21.04175-2.43994,27.00659,6.1665,5.759,8.30811,4.91748,20.21.5232,26.20459l-4.865,38.15234-.43018-.0332.09521.04834.0337-.02783.063.07666.14869.07568c-.00806.01612-.01807.03858-.03028.06934,15.78443,19.27148,32.10327,39.19287,48.40454,58.26514l.36133.42285-.45874.31445c-7.63745,5.23633-15.53491,10.65088-22.64868,15.88672l-.377.2666Z",
    transform: "translate(-314.12165 -99.76826)",
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M696.12165,800.23174h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-314.12165 -99.76826)",
    fill: "#3f3d56"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "492.715 480.274 492.715 480.274 492.715 480.274 492.715 480.274",
    fill: "#f2f2f2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M846.12842,591.45957l-.6051,1.90672-37.67848-11.95547c3.34052,4.41256,14.533,18.1937,26.16243,21.23118,13.89316,3.62856,21.048-1.44333,23.14159-9.45878s-1.66672-15.9385-15.56012-19.56747c-11.77683-3.07615-28.553,3.67819-33.39278,5.808Z",
    transform: "translate(-314.12165 -99.76826)",
    fill: "#f2f2f2"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "350.832 578.731 350.832 578.73 350.832 578.73 350.832 578.731",
    fill: "#f2f2f2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M668.02152,719.30068l-1.99788.10107-1.99886-39.47918c-2.963,4.67443-11.951,19.98482-10.72281,31.94147,1.46742,14.284,8.72405,19.20922,16.965,18.36271s14.34511-7.14366,12.878-21.428c-1.24358-12.10826-13.446-25.456-17.136-29.24323Z",
    transform: "translate(-314.12165 -99.76826)",
    fill: "#f2f2f2"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "63.981 131.667 63.981 131.667 63.981 131.667 63.981 131.667",
    fill: "#f2f2f2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M344.65347,207.87l1.19183-1.60663,31.74905,23.54992c-1.72543-5.25857-7.83252-21.92876-17.84388-28.58027-11.96018-7.94608-20.37486-5.47432-24.95933,1.42589s-3.60277,15.61518,8.3575,23.56174c10.1382,6.736,28.19878,5.7994,33.468,5.35779Z",
    transform: "translate(-314.12165 -99.76826)",
    fill: "#f2f2f2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawTipImage2);
export default __webpack_public_path__ + "static/media/undraw-tip-image-2.5e20e8dfd3d5052d0277493187a92479.svg";
export { ForwardRef as ReactComponent };